<template>
  <div class="component-files">
    <!-- <div class="tips">上传实验等相关材料</div> -->
    <a href="javascript:;" ref="uploader">上传文件</a>
    <ul class="file-list" v-if="tempList.length > 0">
      <li v-for="(item, index) in tempList" :key="index">
        <i class="iconfont" :class="[fileIcon(item.url || item.key)]"></i>
        <div class="info">
          <div class="name">{{ item.name }}</div>
          <div class="actions">
            <div class="progress-warpper" v-if="item.percent">
              <div class="progress-bar">
                <div class="progress" :style="{ width: item.percent + '%' }"></div>
              </div>
              <span class="text">{{ item.percent }}%</span>
              <a href="javascript:;" @click="deleteFile(index)">取消</a>
            </div>
            <div class="completed" v-else>
              <!-- Word/PDF 等与实验资源 courseResource.viewResource 同源：docs.ulearning.cn + furl -->
              <a class="name" href="javascript:;" @click.prevent="openFilePreview(item)">查看</a>
              <a href="javascript:;" @click="deleteFile(index)">删除</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- 全屏文档预览（与 courseResource 文档 iframe 同源能力） -->
    <transition name="doc-preview-fade">
      <div class="document-preview-wrapper" v-if="isDocumentPreviewVisible">
        <div class="document-preview-header">
          <h4>{{ previewDocument.fileName }}</h4>
          <div class="document-preview-actions">
            <a class="preview-button" :href="previewDocumentOriginalPath" target="_blank" download rel="noopener noreferrer">
              下载<span v-if="previewDocumentSizeText">（{{ previewDocumentSizeText }}）</span>
            </a>
            <button class="preview-button" type="button" @click="isDocumentPreviewVisible = false">关闭</button>
          </div>
        </div>
        <div class="document-preview-body">
          <iframe :src="previewDocumentIframeSrc" title="文档预览"></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Obs from "@/plugins/ulearning-obs.js";
import { API_HOST, RESOURCE_SERVER_HOST } from '@/config'
import { setObsConfig, fileIcon, getFullPath, formatSize } from '@/utils/file.js'
import { mapGetters } from "vuex";
export default {
  props: ['list'],
  components: {
  },
  data() {
    return {
      tempList: [],
      /** 是否与课程资源页一致弹出 docs.ulearning 内嵌预览（含 doc/docx、pdf 等） */
      isDocumentPreviewVisible: false,
      previewDocument: {
        fileName: '',
        filePath: '',
        contentSize: null
      }
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user', token: "user/token" }),
    /** 传给下载与预览服务的完整资源地址 */
    previewDocumentOriginalPath() {
      return getFullPath(this.previewDocument.filePath || '')
    },
    previewDocumentSizeText() {
      const s = this.previewDocument.contentSize
      if (s === null || s === undefined || s === '') {
        return ''
      }
      return formatSize(s)
    },
    /** 与 courseResource.currentDocumentPreviewPath 一致：走 docs+furl，不再使用微软嵌入 */
    previewDocumentIframeSrc() {
      const origin = this.previewDocumentOriginalPath
      if (!this.isDocsPreviewCombinedPath(this.previewDocument.filePath, this.previewDocument.fileName)) {
        return origin
      }
      let url = 'https://docs.ulearning.cn?time=1'
      if (origin.indexOf('https://') !== -1) {
        url += '&ssl=1'
      }
      return `${url}&furl=${encodeURIComponent(origin)}`
    }
  },
  watch: {
    list: {
      handler(newVal) {
        this.tempList = newVal.map(item => {
          return {
            name: item.fileName,
            url: item.fileUrl,
            size: item.contentSize !== undefined ? item.contentSize : null
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    let obs = new Obs(setObsConfig({
      uptokenHost: API_HOST,
      authorization: this.token,
      obsHost: RESOURCE_SERVER_HOST,
    }))
    obs.initUpBtn(this.$refs.uploader)
    obs.onBeforeUpload = (file) => {
      let temp = {
        name: file.name,
        size: file.size,
        percent: 0,
      }
      this.tempList.push(temp)
      file.onProgress = (percent) => {
        console.log('progress----file-----' + percent)
        temp.percent = percent
      }
      file.onSuccess = () => {
        console.log('success----file-----',file)
        temp.url = file.obsHost + '/' + file.key
        let fileList = this.tempList.filter(item => item.url).map(item => {
          return {
            fileName: item.name,
            fileUrl: item.url
          }
        })
        this.$emit('update', fileList)
      }
      file.onError = (err) => {
        console.log('error----file-----' + err)
      }
    }
  },
  methods: {
    fileIcon,
    getFileExt(path) {
      const fileName = String(path || '').split('?')[0].toLowerCase()
      const dot = fileName.lastIndexOf('.')
      return dot === -1 ? '' : fileName.substring(dot + 1)
    },
    /**
     * OBS 等资源 URL 常无后缀，需联合展示文件名判断是否走站内 docs 预览
     */
    isDocsPreviewCombinedPath(fileUrl, resourceName) {
      const candidates = [fileUrl, resourceName]
      for (let i = 0; i < candidates.length; i++) {
        const p = candidates[i]
        if (!p) continue
        const ext = this.getFileExt(p)
        if (['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
          return true
        }
      }
      return false
    },
    /** 新建项目附件「查看」：与实验资源 courseResource.viewResource（文档 iframe）同源 */
    openFilePreview(item) {
      const url = item.url
      if (!url) {
        return
      }
      if (this.isDocsPreviewCombinedPath(url, item.name)) {
        this.previewDocument = {
          fileName: item.name || '文件',
          filePath: url,
          contentSize: item.size != null ? item.size : null
        }
        this.isDocumentPreviewVisible = true
        return
      }
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    deleteFile (i) {
      let list = this.tempList.filter(item => item.url).map(item => {
        return {
          fileName: item.name,
          fileUrl: item.url
        }
      })
      list.splice(i, 1)
      this.$emit('update', list)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips{
  color: $--color-text-secondary;
  font-size: 12px;
  line-height: 1.5;
  margin: 10px 0;
}
.file-list{
  max-height: 230px;
  overflow: auto;
  padding: 12px  32px 12px 12px;
  background-color: $--background-color-base;
  li{
    display: flex;
    align-items: center;
    border-radius: 4px;
    &:not(:first-child){
      margin-top: 8px;
    }
    i{
      font-size: 36px;
    }
    .info{
      flex: 1;
      width: 0;
      margin-left: 10px;
      line-height: 20px;
    }
    .name{
      flex: 1;
      @include ellipsis;
    }
  }
  .actions{
    a{
      margin-right: 10px;
    }
  }
  .progress-warpper{
    display: flex;
    align-items: center;
    height: 20px;
    .progress-bar{
      width: 80px;
      height: 6px;
      background-color: $--color-text-placeholder;
      border-radius: 3px;
      overflow: hidden;
      margin-right: 10px;
      .progress{
        height: 100%;
        background-color: $--color-primary;
        transition: width 0.3s ease;
      }
    }
    .text{
      color: $--color-text-secondary;
      margin-right: 10px;
    }
  }
}
/* 与 courseResource.vue 文档全屏预览一致；层级须高于 Dialog */
.document-preview-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.8);
  .document-preview-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3001;
    box-sizing: border-box;
    width: 100%;
    height: 54px;
    padding: 9px 16px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.86);
    h4 {
      float: left;
      margin: 0;
      font-size: 16px;
      line-height: 36px;
    }
    .document-preview-actions {
      float: right;
      display: flex;
      align-items: center;
      line-height: 36px;
      .preview-button {
        display: inline-block;
        box-sizing: border-box;
        min-width: 96px;
        height: 34px;
        margin-left: 14px;
        padding: 0 18px;
        color: #ea5947;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        border: 1px solid #dcdce6;
        border-radius: 4px;
        outline: none;
        text-decoration: none;
      }
      button.preview-button {
        font-family: inherit;
      }
    }
  }
  .document-preview-body {
    box-sizing: border-box;
    height: 100%;
    /* 左右不留边距：iframe 居中窄幅时两侧透出遮罩，避免整块浅灰底占满视口 */
    padding: 74px 0 18px;
    text-align: center;
    background-color: transparent;
    iframe {
      display: block;
      box-sizing: border-box;
      width: 100%;
      max-width: 940px;
      height: calc(100vh - 92px);
      margin: 0 auto;
      background-color: #fff;
      border: none;
      position: relative;
      z-index: 2;
    }
  }
}
.doc-preview-fade-enter-active {
  animation: doc-preview-mask-in 0.3s;
}
.doc-preview-fade-leave-active {
  animation: doc-preview-mask-out 0.3s;
}
/* 与 courseResource 全文预览一致：不用 transform 做入场，减轻 iframe 内表格与遮罩错乱 */
@keyframes doc-preview-mask-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes doc-preview-mask-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>